import { Footer } from '../footer';

// Run this function after page loaded
document.addEventListener("DOMContentLoaded", async function() {
    const footer = new Footer();
    footer.setupFooterSignup();
});
